/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_Upload_RegInputs */

const en_action_upload_reg = /** @type {(inputs: Action_Upload_RegInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload Registration`)
};

const es_action_upload_reg = /** @type {(inputs: Action_Upload_RegInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subir Registro`)
};

const fr_action_upload_reg = /** @type {(inputs: Action_Upload_RegInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uploader l'enregistrement`)
};

const de_action_upload_reg = /** @type {(inputs: Action_Upload_RegInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrierung hochladen`)
};

const id_action_upload_reg = /** @type {(inputs: Action_Upload_RegInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unggah Pendaftaran`)
};

/** @type {(inputs: Action_Upload_RegInputs) => LocalizedString} */
const ja_action_upload_reg = en_action_upload_reg;

/** @type {(inputs: Action_Upload_RegInputs) => LocalizedString} */
const zh_action_upload_reg = en_action_upload_reg;

/** @type {(inputs: Action_Upload_RegInputs) => LocalizedString} */
const ar_action_upload_reg = en_action_upload_reg;

/** @type {(inputs: Action_Upload_RegInputs) => LocalizedString} */
const it_action_upload_reg = en_action_upload_reg;

/** @type {(inputs: Action_Upload_RegInputs) => LocalizedString} */
const ru_action_upload_reg = en_action_upload_reg;

/** @type {(inputs: Action_Upload_RegInputs) => LocalizedString} */
const pt_action_upload_reg = en_action_upload_reg;

/** @type {(inputs: Action_Upload_RegInputs) => LocalizedString} */
const ko_action_upload_reg = en_action_upload_reg;

/**
* | output |
* | --- |
* | "Upload Registration" |
*
* @param {Action_Upload_RegInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const action_upload_reg = /** @type {((inputs?: Action_Upload_RegInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_Upload_RegInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_upload_reg(inputs)
	if (locale === "es") return es_action_upload_reg(inputs)
	if (locale === "fr") return fr_action_upload_reg(inputs)
	if (locale === "de") return de_action_upload_reg(inputs)
	if (locale === "ja") return ja_action_upload_reg(inputs)
	if (locale === "zh") return zh_action_upload_reg(inputs)
	if (locale === "ar") return ar_action_upload_reg(inputs)
	if (locale === "id") return id_action_upload_reg(inputs)
	if (locale === "it") return it_action_upload_reg(inputs)
	if (locale === "ru") return ru_action_upload_reg(inputs)
	if (locale === "pt") return pt_action_upload_reg(inputs)
	return ko_action_upload_reg(inputs)
});